module.exports = __webpack_public_path__ + "fonts/baronsans-roman-webfont.081f8605.woff";